const { PageFeatureFlags } = require('models/flags/page');

/**
 * This is used to define the default feature flags until the connection to LaunchDarkly is completed.
 * @type {import('launchdarkly-react-client-sdk').LDFlagSet} Name of the feature flag and its default value.
 */
const defaultLDFlags = {
  [PageFeatureFlags.ShowCanadaPostBanner]: false,
};

module.exports.defaultLDFlags = defaultLDFlags;
